import { ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useSettingsStore } from "../stores/settingsStore";

/**
 * @deprecated Use useSettingsStore directly from '@/stores/settingsStore'
 * This component is kept for backwards compatibility only.
 *
 * Example migration:
 * ```tsx
 * // OLD
 * const { darkMode, toggleDarkMode } = useSettings();
 *
 * // NEW (with useShallow for optimal performance)
 * import { useSettingsStore } from '@/stores/settingsStore';
 * import { useShallow } from 'zustand/react/shallow';
 *
 * const { darkMode, toggleDarkMode } = useSettingsStore(useShallow(state => ({
 *   darkMode: state.darkMode,
 *   toggleDarkMode: state.toggleDarkMode
 * })));
 * ```
 */
export function SettingsProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const language = useSettingsStore((state) => state.language);

  // Sync Zustand language with i18n (one-way sync only)
  useEffect(() => {
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  return <>{children}</>;
}

/**
 * @deprecated Use useSettingsStore directly
 * Legacy hook for backwards compatibility
 */
// eslint-disable-next-line react-refresh/only-export-components
export function useSettings() {
  return useSettingsStore();
}
